import { render, staticRenderFns } from "./BidderInfoCell.vue?vue&type=template&id=aa2e30c0&scoped=true"
import script from "./BidderInfoCell.vue?vue&type=script&lang=js"
export * from "./BidderInfoCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2e30c0",
  null
  
)

export default component.exports